import { ethers, BigNumber } from "ethers"
import Notification from "@/components/Notification"
import { batchAirToken, batchAirEth, errorHandler } from "@/utils"
import { SENDERTOKENCONTRACT, SENDTOKEN_PRICE } from "@/config"
import { PublicClient, WalletClient } from "viem"

/**
 * 批量空投发送函数
 * @param chainId 当前链ID
 * @param signer 签名对象
 * @param tokenInfo 代币信息 { address, decimals }
 * @param tokens 接收地址数组
 * @param amounts 数量数组
 * @param senderBase 每批次数量
 * @param senderTotalNumber 总批次数
//  * @param setIsSender 状态更新函数
 * @param setSenderTotalNumber 状态更新函数
 */

async function senderTokenAddressHandler({
    chainId,
    walletClient,
    publicClient,
    tokenInfo,
    tokens,
    amounts,
    senderBase,
    senderTotalNumber,
    isMainAddress,
    isVip
}: {
    chainId: number
    walletClient: WalletClient
    publicClient: PublicClient
    tokenInfo: { address: string; decimals: number }
    tokens: string[]
    amounts: string[]
    senderBase: number
    senderTotalNumber: number
    isMainAddress: boolean,
    isVip: boolean
}) {
    const nubmer = JSON.parse(JSON.stringify(senderTotalNumber))
    let index = 0

    console.log('isVip::: ', isVip);

    const yagongPrice = isVip ? Number(SENDTOKEN_PRICE[chainId]) / 2 : Number(SENDTOKEN_PRICE[chainId])
    const handler = () => {
        const amountArr = amounts.slice(senderBase * index, senderBase * (index + 1))
        const tokenArr = tokens.slice(senderBase * index, senderBase * (index + 1))
        let _totalValue = BigNumber.from("0")

        amountArr.forEach((element) => {
            _totalValue = _totalValue.add(ethers.utils.parseEther(element))
        })
        let price = yagongPrice + Number(ethers.utils.formatEther(_totalValue))
            console.log('isMainAddress::: ', isMainAddress);

        if (isMainAddress) {
            batchAirEth(SENDERTOKENCONTRACT[chainId], walletClient,publicClient, tokenArr, amountArr, 18, price)
                .then(() => {
                    index += 1
                    if (index === nubmer) {
                        Notification.Success(`发送完成`)
                        // setIsSender(false)
                        // setSenderTotalNumber(0)
                    } else {
                        price = yagongPrice
                        Notification.Success(`第${index + 1}次发送成功`)
                        // const res = senderTotalNumber - 1
                        // setSenderTotalNumber(res)
                        handler()
                    }
                })
                .catch((error) => {
                    // setIsSender(false)
                    console.log(error)
                    Notification.Error(errorHandler(error))
                })
        } else {
          
            batchAirToken(
                SENDERTOKENCONTRACT[chainId],
                walletClient,
                publicClient,
                tokenInfo.address,
                tokenArr,
                amountArr,
                tokenInfo.decimals,
                yagongPrice,
            )
                .then(() => {
                    index += 1
                    console.log(index, nubmer, 'indexindexindexindex');
                    if (index === nubmer) {
                        Notification.Success(`发送完成`)
                    } else {
                        Notification.Success(`第${index + 1}次发送成功`)
                        handler()
                    }
                })
                .catch((error) => {
                    console.log(error, 'err');
                    Notification.Error(String(error))
                })
        }
    }

    handler()
}

export default senderTokenAddressHandler